var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_23201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_23201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30603 8.40002C9.05253 8.40002 8.83828 8.31378 8.66328 8.14128C8.48828 7.96878 8.40078 7.75502 8.40078 7.50002V6.30002C8.40078 6.04502 8.48653 5.83127 8.65803 5.65877C8.82953 5.48627 9.04203 5.40002 9.29553 5.40002C9.54903 5.40002 9.76328 5.48627 9.93828 5.65877C10.1133 5.83127 10.2008 6.04502 10.2008 6.30002V7.50002C10.2008 7.75502 10.115 7.96878 9.94353 8.14128C9.77203 8.31378 9.55953 8.40002 9.30603 8.40002ZM9.30603 16.8C9.05253 16.8 8.83828 16.7138 8.66328 16.5413C8.48828 16.3688 8.40078 16.155 8.40078 15.9V13.5C8.40078 13.245 8.48653 13.0313 8.65803 12.8588C8.82953 12.6863 9.04203 12.6 9.29553 12.6C9.54903 12.6 9.76328 12.6863 9.93828 12.8588C10.1133 13.0313 10.2008 13.245 10.2008 13.5V15.9C10.2008 16.155 10.115 16.3688 9.94353 16.5413C9.77203 16.7138 9.55953 16.8 9.30603 16.8ZM6.60078 21.6C6.11745 21.6 5.69661 21.4238 5.33828 21.0713C4.97995 20.7188 4.80078 20.295 4.80078 19.8V4.20002C4.80078 3.70502 4.97995 3.28128 5.33828 2.92878C5.69661 2.57628 6.11745 2.40002 6.60078 2.40002H17.4008C17.8841 2.40002 18.305 2.57628 18.6633 2.92878C19.0216 3.28128 19.2008 3.70502 19.2008 4.20002V19.8C19.2008 20.295 19.0216 20.7188 18.6633 21.0713C18.305 21.4238 17.8841 21.6 17.4008 21.6H6.60078ZM6.60078 19.8H17.4008V11.4H6.60078V19.8ZM6.60078 9.60002H17.4008V4.20002H6.60078V9.60002Z",
    fill: "#d3135a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenR);
export default __webpack_public_path__ + "static/media/kitchen_r.af06c5032988c772bb230741baca9d28.svg";
export { ForwardRef as ReactComponent };